<template>
    <a-layout class="newHome">
        <a-layout-header>
            <PageNav></PageNav>
        </a-layout-header>
        <a-layout-content>
            <!--    banner_swiper  -->
            <div class="banner">
                <swiper class="bannerSwiper"
                        :space-between="20"
                        :modules="modules"
                        :autoplay="{delay:5000}"
                        :navigation="{
                          nextEl: '.banner-next',
                          prevEl: '.banner-prev'
                        }"
                        :loop="true"
                        slides-per-view="1">
                    <swiper-slide class="swiperSlide" v-for="(item,index) in bannerSwiperOption" :key="index">
                        <div class="contentBox" :style="{'background-image': `url(${item.cover})`}">
                            <div class="contentBox-info">
                                <h1 class="title">{{ item.title }}</h1>
                                <p class="context">{{ item.desc }}</p>
                                <a-button class="button" @click="goToQuotesOrLogin">{{ $t('home.go_see') }}</a-button>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
                <a-button class="banner-button banner-prev">
                    <icon-left />
                </a-button>
                <a-button class="banner-button banner-next">
                    <icon-right />
                </a-button>
            </div>
            <!--      notice-->
            <div class="notice">
                <div class="noticeContent">
                    <div class="contentInfo">
                        <img :src="require(`@/assets/images/home/horn-${userTheme}.svg`)" alt="">
                        <span>{{ noticeGroup[0] ? noticeGroup[0]['name'] : '' }}</span>
                    </div>
                    <icon-right class="color-black cursor" size="16"/>
                </div>
            </div>
            <!--      containerWarp-->

            <div class="containerWarp">
                <div class="hotCoin">
                    <div class="title-container">
                    <h1 class="title">{{ $t('home.hot_cryptocurrency') }}</h1>

                    </div>
                    <div class="tab">
                        <div class="item"
                             v-for="(item, index) in tabOption"
                             :key="index" @click="switchCurrency(index)">
                            <span>{{ item }}</span>
                        </div>
                    </div>
                    <div class="list-container">
                        <div class="_head">
                            <div class="item" v-for="(item,index) in tableColumns" :key="'header-'+index">
                                <span>{{ item }}</span>
                            </div>
                        </div>
                        <div v-if="currencyList.length === 0" class="_cell" style="justify-content: center; color: #999;">
                            <div style="text-align: center;">
                                <div style="font-size: 16px; margin-bottom: 10px;">📊 {{ $t('common.loading') }}</div>
                                <div style="font-size: 12px;">{{ $t('common.no_records') }}</div>
                            </div>
                        </div>
                        <div class="_cell" v-for="(item,index) in currencyList" :key="'currency'+(item.id || index)" @click="goToTrade(item)">
                            <div class="item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                                    <path d="M7.72569 12.5967C7.2741 12.3471 6.7259 12.3471 6.27432 12.5967L3.61611 14.0661C3.25083 14.2681 2.81354 13.96 2.88074 13.548L3.41223 10.2898C3.48887 9.81987 3.33791 9.3415 3.00543 9.00074L0.716954 6.65523C0.432749 6.36394 0.597017 5.87326 0.999316 5.81179L4.0759 5.34173C4.57038 5.26618 4.99467 4.94911 5.20721 4.49628L6.54738 1.64106C6.72734 1.25766 7.27266 1.25766 7.45262 1.64106L8.79279 4.49628C9.00533 4.94911 9.42962 5.26618 9.9241 5.34173L13.0007 5.81179C13.403 5.87326 13.5673 6.36394 13.283 6.65523L10.9946 9.00074C10.6621 9.3415 10.5111 9.81987 10.5878 10.2897L11.1193 13.548C11.1865 13.96 10.7492 14.2681 10.3839 14.0661L7.72569 12.5967Z" stroke="var(--content-tertiary)"></path>
                                </svg>
                                <div class="coin">
                                    <img class="coin-img" :src="item['icon'] || '/favicon.ico'" :alt="item['symbol']">
                                    <span class="color-black">
                                        {{ item.symbol || 'N/A' }}
                                        <b class="font-12">/ USDT</b>
                </span>
                                    <img v-if="index < 3" class="hot" src="@/assets/hot.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                <span :class="{'color-red':item.change_rate <= 0,'color-green':item.change_rate > 0}">
                                    {{ item.new_price ? $util.thousandSeparator(item.new_price, item.decimals || 2) : '0.00' }}
                </span>
                            </div>
                            <div class="item">
                <span :class="{'color-red':item.change_rate <= 0,'color-green':item.change_rate > 0}">
                                    {{ item.change_rate ? (item.change_rate > 0 ? '+' : '') + $util.thousandSeparator(item.change_rate, 2) + '%' : '0.00%' }}
                </span>
                            </div>
                            <div class="item">
                                <span class="color-black">{{ item.quota ? $util.bigNumberToString(item.quota) : '0' }}</span>
                            </div>
                            <div class="item">
                                <span class="color-black">{{ item.quantity ? $util.bigNumberToString(item.quantity) : '0' }}</span>
                            </div>
                            <div class="item">
                                <kline v-if="item.id" :currencyId="item.id" :change="item.change_rate"></kline>
                                <span v-else class="color-gray">-</span>
                            </div>
                            <div class="item">
                                <span class="color-primary font-bold" @click.stop="goToTrade(item)" style="cursor: pointer;">{{ $t('home.trade') }}</span>
                            </div>
                        </div>
                    </div>
                                            <a-button class="seeAll" @click="$router.push('/rank')">{{ $t('home.view_all') }}
                        <icon-right/>
                    </a-button>

                    <div class="anmationCoin">
                        <div class="row">
                            <div class="item" v-for="(item,index) in allCurrency" :key="'s1'+item.id">
                                <img :src="item['icon']" alt="">
                                <span class="coin">{{ item['symbol'] }}</span>
                                <div class="info">
                                    <span>{{ $util.thousandSeparator(item.new_price, item.decimals) }}</span>
                                    <span
                                        :class="{'color-red':item.change_rate <= 0,'color-green':item.change_rate > 0}">
                    <icon-caret-down v-if="item.change_rate <= 0"/>
                      <icon-caret-up v-else/>
                      {{ $util.thousandSeparator(item.change_rate, 2) }}%
                  </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="item" v-for="(item,index) in currencyList" :key="'s2'+item.id">
                                <img :src="item['icon']" alt="">
                                <span class="coin">{{ item['symbol'] }}</span>
                                <div class="info">
                                    <span>{{ $util.thousandSeparator(item.new_price, item.decimals) }}</span>
                                    <span
                                        :class="{'color-red':item.change_rate <= 0,'color-green':item.change_rate > 0}">
                  <icon-caret-down v-if="item.change_rate <= 0"/>
                      <icon-caret-up v-else/>
                      {{ $util.thousandSeparator(item.change_rate, 2) }}%
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- <div class="copy">
                    <div class="copyOrder">
                        <div class="info">
                                                    <h1 class="title">{{ $t('home.copy_trading') }}</h1>
                        <span class="contxt">{{ $t('home.copy_trading_desc') }}</span>
                            <div class="column">
                                <div class="item">
                                    <span>{{ IndexConfig['trade_user'] }}</span>
                                                                          <span>{{ $t('home.expert_count') }}</span>
                                </div>
                                <div class="item">
                                    <span>{{ IndexConfig['copy_user'] }}</span>
                                                                          <span>{{ $t('home.follower_count') }}</span>
                                </div>
                                <div class="item">
                                    <span>{{ IndexConfig['total_p'] }}</span>
                                                                          <span>{{ $t('home.realized_pnl') }}</span>
                                </div>
                            </div>
                            <a-button class="button" @click="$router.push('/copyTraders')">
                                {{ $t('home.start_copy_trading') }}
                                <icon-right/>
                            </a-button>
                        </div>
                        <div class="bgImage">
                            <img :src="require(`@/assets/images/home/Copyhomebg_${userTheme}.png`)" alt="">
                        </div>
                    </div>
                    <div class="tradeList">
                        <div class="list">
                            <div class="item" v-for="i in 20">
                                <div class="top">
                                    <div class="imgBox">
                                        <img src="@/assets/images/user-image.png" alt="">
                                    </div>
                                    <div class="usInfo">
                                        <div class="usName">
                                            <span>{{ randName[i] ? randName[i] : 'CBUSER-TB130' + i }}</span>
                                        </div>
                                        <div class="tooltip">
                                            <span>@{{ randName[i] ? randName[i] : 'CBUSER-TB130' + i }}</span>
                                        </div>
                                    </div>
                                </div>
                                <p class="price color-green">
                                    +{{ parseFloat(Math.random(1000, 100000) * 1000).toFixed(2) }}%</p>
                                <div class="cell">
                                    <span class="color-gray">{{ $t('home.profit_rate') }}</span>
                                    <span class="color-gray">{{ $t('home.thirty_days') }}</span>
                                </div>
                                <div class="canvasBox">
                                    <canvas class="canvas"></canvas>
                                </div>
                                <div class="cell">
                                    <span class="color-gray">{{ $t('home.total_profit') }}</span>
                                    <span
                                        class="color-black">${{
                                            parseFloat(Math.random(10000, 100000000) * 100000).toFixed(2)
                                        }}</span>
                                </div>
                                <div class="cell">
                                    <span class="color-gray">{{ $t('home.follower_total_profit') }}</span>
                                    <span
                                        class="color-black">${{
                                            parseFloat(Math.random(10000, 100000000) * 1000).toFixed(2)
                                        }}</span>
                                </div>
                                <div class="cell">
                                    <span class="color-gray">AUM</span>
                                    <span
                                        class="color-black">${{
                                            parseFloat(Math.random(10000, 100000000) * 10000000).toFixed(2)
                                        }}</span>
                                </div>
                                <div class="cell">
                                    <span class="color-gray">{{ $t('home.max_drawdown') }}</span>
                                    <span
                                        class="color-black">{{
                                            parseFloat(Math.random(10000, 100000000) * 1000).toFixed(2)
                                        }}%</span>
                                </div>
                                <div class="bottom">
                                    <div class="imgGroup">
                                        <image src="https://static-dev.bbbtrade.net/coin/btc.png"></image>
                                        <image src="https://static-dev.bbbtrade.net/coin/eth.png"></image>
                                        <image src="https://static-dev.bbbtrade.net/coin/trx.png"></image>
                                    </div>
                                    <div class="right">
                                        <span><icon-swap/>{{
                                                parseFloat(Math.random(1000, 100000) * 100).toFixed(0)
                                            }}</span>
                                        <span><icon-archive/>{{
                                                parseFloat(Math.random(1000, 100000) * 100).toFixed(2)
                                            }}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="exchange">
                    <div class="card">
                        <h1 class="title">{{ $t('home.trusted_platform') }}</h1>
                        <p class="subTitle">{{ $t('home.security_matters') }}</p>
                        <a href="" class="boxList">
                            <div class="boxItem">
                                <img src="@/assets/images/home/one_proof_white.png" alt="">
                                                                  <p>{{ $t('home.reserve_proof') }}</p>
                                  <span>{{ $t('home.reserve_commitment', { site_name: config['site_name'] }) }}</span>
                            </div>
                            <div class="boxItem">
                                <img src="@/assets/images/home/two_storage_white.png" alt="">
                                                                  <p>{{ $t('home.cold_storage') }}</p>
                                  <span>{{ $t('home.cold_storage_desc') }}</span>
                            </div>
                            <div class="boxItem">
                                <img src="@/assets/images/home/three_protection_white.png" alt="">
                                                                  <p>{{ $t('home.protection_fund') }}</p>
                                  <span>{{ $t('home.protection_fund_desc') }}</span>
                            </div>
                        </a>
                    </div>
                    <div class="sponsor" @mouseenter="messiHover = false" @mouseleave="messiHover = true">
                        <div class="info">
                            <p>{{ config['site_name'] }}</p>
                                                              <p>{{ $t('home.brand_ambassador') }}</p>
                        </div>
                        <div class="bgImage">
                            <img :src="require('@/assets/images/home/messi-default-new-compress.png')" alt="" v-if="messiHover">
                            <img :src="require('@/assets/images/home/messi-hover-new-compress.png')" alt="" v-else>
                        </div>
                    </div>
                    <!-- 下载卡片区域已隐藏 -->
                    <div class="card" style="display: none;">
                        <h1 class="title">{{ $t('home.trade_anywhere') }}</h1>
                        <p class="subTitle">{{ $t('home.trade_anywhere_desc') }}</p>
                        <div class="download">
                            <img class="bgImage" :src="require('@/assets/web-download-zh_CN.png')" alt="">
                            <div class="download-right">
                                <div class="codeBox">
                                    <div class="codeImage">
                                        <img :src="config['dpage'] || require('@/assets/qrcode.png')" alt="">
                                    </div>
                                    <div class="downInfo">
                                        <p>{{ $t('home.scan_download') }}</p>
                                        <p>{{ $t('home.ios_app_only') }}</p>
                                    </div>
                                </div>
                                <div class="middel">
                                    <!-- 仅保留iOS App Store下载 -->
                                    <div class="item" @click="downloadIOSFromHome">
                                        <img :src="require('@/assets/appStore.png')" alt="">
                                        <p>{{ $t('home.app_store') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="join">
                    <h1>{{ $t('home.ready_crypto') }}</h1>
                    <p>{{ config['site_name'] }}</p>
                    <div class="column">
                        <div class="item">
                            <p>{{ $t('home.twenty_four_hour_volume') }}</p>
                            <span>{{ $t('home.twenty_four_hour_volume') }}</span>
                        </div>
                        <div class="item">
                            <p>{{ allCurrency.length }}+ </p>
                            <span>{{ $t('home.crypto_types') }}</span>
                        </div>
                        <div class="item">
                            <p>{{ $t('home.registered_users') }}</p>
                            <span>{{ $t('home.registered_users') }}</span>
                        </div>
                        <div class="item">
                            <p>0.10%</p>
                            <span>{{ $t('home.min_fee_rate') }}</span>
                        </div>
                    </div>
                    <a-button class="button" @click="goToQuotesOrLogin">
                        {{ $t('home.worry_free') }}
                    </a-button>
                </div>
            </div>
        </a-layout-content>
        <a-layout-footer>
            <Footer></Footer>
        </a-layout-footer>
        
        <!-- 漂浮在线客服按钮 -->
        <div class="floating-customer-service" @click="openCustomerService">
            <div class="service-icon">
                <icon-customer-service />
            </div>
            <div class="service-text">{{ customerServiceText }}</div>
        </div>
    </a-layout>
</template>
<script>
// import { methods } from "@arco-design/web-vue/es/_utils/date";
import service from './service';

export default service;
</script>
<style lang="scss" scoped>
@import "newHome.scss";

.logo_box {
    display: flex;
    align-content: center;
    line-height: 94px;
    padding: 0 60px;
}
</style>
